export default {
  title: "Savdo nuqtalari",
  name: "Savdo nuqtasi nomi",
  namingNoSpecified: "Nom ko‘rsatilmagan",
  tradingPoint: "Savdo nuqtasi",
  addressNoSpecified: "Manzil ko‘rsatilmagan",
  info: "Savdo nuqtasi haqida ma’lumot",
  add: {
    title: "Savdo nuqtasini yaratish",
    noOperations: "Hech qanday operatsiya amalga oshirilmagan",
  },
  historyOperation: "Cheklar tarixi",
  employee: "Xodim",
  customer: "Mijoz",
  source: "Manba",
  typeOperation: "Operatsiya turi",
  typeActivity: "Faoliyat turi",
  writing: "Chiqim",
  accrual: "Hisobga qo‘shish",
  sumBuy: "Xarid summasi",
  sumWrite: "Chiqim summasi",
  toPay: "To‘lanishi kerak",
  totalCashback: "Umumiy mukofot",
  salePopup: "Chegirma",
  types: {
    balance_up: "Balansni to‘ldirish",
    balance_down: "Mablag‘ni yechish",
    tsp_approve: "Chek bo‘yicha hisob-kitob",
    balance_refill: "Balansni to‘ldirish",
    tariff_change: "Tarif xaridi",
    cashback_approve: "Mijoz safaridagi mukofot",
    cashback_charge: "Chek. Ballarni yechish",
    certificate_charge: "Hisobga qo‘shish. Sovg‘a kartasini ishlatish",
    certificate_debt: "Chiqim. Sovg‘a kartasini chiqarish",
    certificate_refund: "Sovg‘a kartasini chiqarish bo‘yicha qaytarish",
    rc_withdraw: "Chek. Ballarni qabul qilish",
    tsp_commission_fee: "Chek. Komissiya",
    tsp_commission_revert:
      "1 aprel - hisobga qo‘shish sanasi oralig‘ida noto‘g‘ri yechilgan summani qayta hisoblash",
    tsp_commission_correct:
      "Qabul qilingan ballarning 1% miqdorida hisob-kitobni tuzatish",
    manual_commission_approve: "Chek. Komissiya bo‘yicha hisob-kitob",
    manual_withdraw: "Mablag‘ni yechish",
    cashback_decline: "Chekni bekor qilish",
    rc_processing_receipts: "Kassa apparati cheki",
    cashback_approve_decline: "Mijoz safaridagi mukofotni bekor qilish",
    partner_manual_withdraw: "Mablag‘ni yechish",
    inner_cashback_charge: "Chek. Mukofotni yechish",
    inner_cashback_approve: "Chek bo‘yicha hisob-kitob",
    tsp_approve_payment: "Chek. Mablag‘ni yechish",
    rc_withdraw_approve: "Chek. Ballar bilan to‘lov uchun hisobga qo‘shish",
    withdraw_payment: "Chek. Mablag‘ni yechish",
    prodazha_top_mesta: "rcpay’da top-o‘rin xaridi",
    reserving_funds_withdrawal: "To‘lanishi kerak bo‘lgan mablag‘ni ajratish",
    refund_reserved_funds_withdrawal: "Ajratilgan mablag‘ni qaytarish",
    withdraw_reserved_funds: "Mablag‘ni yechish",
  },
  organizations: "Yuridik shaxs",
  moderationModalTitle: "Moderatsiyadan xabar",
  clients: "mijozga: ",
  other: "komissiya: ",
  total: "Jami: ",
  draft: "Qoralama",
  itsAppearAfterCreateShop: "Savdo nuqtasi yaratilgandan keyin ko‘rinadi",
  inRCPay: {
    published: "RC PAYda e’lon qilingan",
    unpublished: "RC PAYda e’lon qilinmagan",
  },
  promotion: "Rivojlantirish",
  openInRCPay: "RC PAYda ochish",
  couldntSendShopToModeration: "Savdo nuqtasini saqlash muvaffaqiyatsiz tugadi",
  shopChangesSuccessSaved: "Savdo nuqtasi ma’lumotlari muvaffaqiyatli saqlandi",
  forLayoultyCreateEmployee:
    "Sadoqat dasturi bilan ishlash uchun «Kassirlar» bo‘limida xodim yaratib, uni ushbu savdo nuqtasiga biriktirish kerak.",
  changesSendedToModeration:
    "Savdo nuqtasi ma’lumotlaridagi o‘zgarishlar moderatsiyaga yuborildi",
  someChangesNeedModeration:
    "Kiritilgan ba’zi o‘zgarishlar moderatsiyani talab qiladi",
  changesUpdateAfterModeration:
    "RC PAYda ko‘rsatiladigan savdo nuqtasi kartasida ular faqat moderatsiya tasdiqlangandan keyin yangilanadi.",
  connectedPaymentMethod: "Savdo nuqtasida to‘lov usullari ulanishgan.",
  ifNeedDeleteConnectWithUs:
    "Agar uni o‘chirish kerak bo‘lsa, texnik yordamga murojaat qiling",
  ifNeedDeleteConnectWithUsSuccess: "Elektron pochta buferga nusxalandi",
  someFieldsUncorrect: "Ba’zi maydonlar noto‘g‘ri to‘ldirilgan",
  backToEditingToFixIt:
    "Ularni tuzatish uchun tahrirlashga qayting. Agar saqlamasdan chiqmoqchi bo‘lsangiz, «O‘tkazib yuborish» tugmasini bosing.",
  wannaQuit: "Chiqmoqchimisiz?",
  allNotSavedChangesWillRemove:
    "Saqlanmagan barcha o‘zgarishlar yo‘qoladi. Ularni saqlash uchun orqaga qayting.",
  cancelCreationPointModal: {
    title: "Savdo nuqtasini yaratishni bekor qilmoqchimisiz?",
    subtitle:
      "Savdo nuqtasi bo‘yicha kiritilgan ma’lumotlar saqlanmaydi. Tahrirlashga qaytish uchun «Orqaga» tugmasini bosing.",
  },
  moderationModal: {
    title: "Savdo nuqtasi muvaffaqiyatli yaratildi va moderatsiyaga yuborildi",
    subtitle:
      "Sadoqat dasturi bilan ishlash uchun «Kassirlar» bo‘limida xodim yaratib, uni ushbu savdo nuqtasiga biriktirish kerak.",
  },
  deletePromotionModal: {
    title:
      "Rivojlantirish xizmatlari faol bo‘lgan savdo nuqtasini o‘chirishni xohlaysizmi?",
    subtitle:
      "O‘chirgandan keyin rivojlantirish xizmatlari to‘xtaydi. Rivojlantirish uchun to‘langan mablag‘ qaytarilmaydi. Savdo nuqtasi ma’lumotlarini tiklash mumkin bo‘lmaydi.",
  },
  deleteModal: {
    title: "Savdo nuqtasini o‘chirishni xohlaysizmi?",
    subtitle: "O‘chirgandan keyin ma’lumotlarni tiklash mumkin bo‘lmaydi.",
    shopDeleted: "Savdo nuqtasi o‘chirildi",
  },
  lessTariffModal: {
    title: "Siz tarifingiz bo‘yicha maksimal savdo nuqtalarini yaratdingiz",
    subtitle:
      "Ko‘proq savdo nuqtalarini yaratish uchun boshqa tarif sotib olish kerak.",
  },
  validation: {
    specifyMailOrRemoveField:
      "Elektron pochta manzilini kiriting yoki maydonni o‘chiring",
    specifyLinkAddressOrRemove:
      "Havola manzilini kiriting yoki maydonni o‘chiring",
    couldntSendShopToModeration:
      "Savdo nuqtasini moderatsiyaga yuborib bo‘lmadi",
    someImagesCouldntProcess:
      "Ba’zi rasmlarni qayta ishlashning imkoni bo‘lmadi. Boshqa rasmlarni yuklab ko‘ring",
  },
  creationTab: {
    main: "Asosiy",
    loyalty: "Sadoqat dasturi",
    addressAndOpeningHours: "Manzil va ish vaqti",
    contacts: "Kontaktlar",
    foto: "Foto",
  },
  stepFromTo: "{from}/{total} qadam",
  createShopAndContinue: "Savdo nuqtasini yaratish va davom ettirish",
  createShop: "Savdo nuqtasini yaratish",
  message: {
    dataSavedToDraft: "Savdo nuqtasi ma’lumotlari qoralama sifatida saqlandi",
    dataSavedAndSendToModeration:
      "O‘zgarishlar saqlandi va moderatsiyaga yuborildi",
    dataSuccessSaved: "O‘zgarishlar muvaffaqiyatli saqlandi",
    fillCorrectSpecifiedFields: "Ko‘rsatilgan maydonlarni to‘g‘ri to‘ldiring",
    fillCorrectAllRequiredFields:
      "Barcha majburiy maydonlarni to‘g‘ri to‘ldiring",
  },
  describeYourCompany:
    "Kompaniyangizni batafsil tasvirlang. Iltimos, matnda hashtag (#) va emotikonlardan foydalanmang. Manzillar, kontaktlar va ish rejimi keyingi bo‘limlarda ko‘rsatiladi.",
  willDisplayToUserInRCPay: "RC PAY foydalanuvchilarida ko‘rinadi",
  activityTooltip:
    "Tanlangan toifalar bo‘yicha filtrlashda sizning muassasangiz RC PAY qidiruv natijalarida ko‘rsatiladi.",
  afterModerationEntityEditingDisable:
    "Moderatsiya tasdiqlangandan so‘ng yuridik shaxsni tahrirlash mumkin emas. O‘zgartirish uchun texnik yordamga murojaat qiling.",
  description: "Savdo nuqtasi tavsifi",
  charsLimit: {
    min: "Minimal belgilar soni - {minChars}",
    max: "Maksimal belgilar soni - {maxChars}",
  },
  features: "Xususiyatlar",
  selectedFeaturesWillDisplayInCard:
    "Tanlangan opsiyalar RC PAY’da savdo nuqtasi kartasida teglar sifatida ko‘rsatiladi",
  catalogTitles: "RC PAYda mahsulotlar/xizmatlar blokining nomi",
  catalogTitlesTooltip:
    "Savdo nuqtasi mahsulotlar/xizmatlar ro‘yxati uchun umumiy blok nomi. Faqat RC PAY sahifasida qo‘llaniladi.",
  totalPercentReward: "Umumiy mukofot foizi",
  totalRewardLabel: "Umumiy mukofot %",
  totalPercentRewardValue:
    "Umumiy hisobga qo‘shiladigan mukofot foizi (4 dan 25 gacha).",
  rewardWillPayToClients:
    "Mijozlarga mukofot miqdori mukofot taqsimlash ssenariylari bo‘yicha to‘lanadi.",
  checkRewardDistribution: "Mukofot taqsimlash ssenariylarini ko‘ring",
  activeWait: "Mukofot kechikishi",
  activeWaitTooltip:
    "Mijoz xaridi amalga oshirilgandan so‘ng mukofot hisobga qo‘shilishi uchun kunlar soni (0 dan 14 gacha)",
  clientDiscount: "RC PAY mijozlariga chegirma",
  clientDiscountTooltip:
    "Savdo nuqtasida RC GROUP sadoqat dasturi mijozlariga beriladigan chegirma foizi (0 dan 99 gacha)",
  shopPaylable: "Savdo nuqtasi RC ballari bilan to‘lovni qabul qiladi",
  shopPaylableDescription:
    "RC PAY’da ro‘yxatdan o‘tgan mijozlar xaridning 99,9% gacha ballar bilan to‘lay oladi",
  enteredDataNotNeedModeration:
    "Kiritilgan ma’lumotlar moderatsiyani talab qilmaydi va savdo nuqtasi yaratilganda yoki tahrirlanganda darhol qo‘llaniladi (agar yuridik shaxs tasdiqlangan bo‘lsa).",
  address: "Manzil",
  ifNoYourShopSelectNear:
    "Agar xaritada savdo nuqtangiz manzili ko‘rinmasa, eng yaqinini tanlang va texnik yordamga murojaat qiling",
  startEnteringAddress: "Kiritishni boshlang va ro‘yxatdan manzilni tanlang",
  addressComment: "Manzilga izoh",
  specifyWayToGetYouShop:
    "Savdo nuqtangizga qanday borishni ko‘rsating, oldindan qo‘ng‘iroq qilish zarurati yoki boshqa qo‘shimcha ma’lumot (ixtiyoriy)",
  period: {
    workdays: "Ish kunlari D-SH",
    weekend: "Dam olish kunlari S-Y",
    allDay: "Har kuni D-Y",
    aroundClock: "24/7",
  },
  catalog: "Katalog",
  intervals: "Oraliqlar",
  weekdays: "Hafta kunlari",
  selectedAllDays: "Hafta kunlari tanlangan",
  workHoursInOtherDays: "Boshqa kunlardagi ish vaqti",
  workDays: "Ish kunlari",
  workDaysMobileSubtitle:
    "Savdo nuxtasi ishlaydigan haftaning kunlarini yoki oraliqlarini tanlang (shu maydondagi tanlangan barcha kunlar uchun ish vaqti bir xil bo‘ladi).",
  workDaysTooltips: [
    "Savdo nuqtasi ishlaydigan haftaning kunlarini yoki oraliqlarini tanlang (masalan, D-SH, 10:00–20:00).",
    "Keyin «Boshqa kunlardagi ish vaqti» tugmasini bosing va farq qiladigan kunlarni tanlang (masalan, S, 12:00–16:00).",
  ],
  specifyWorkTimeInSelectedDays: "Tanlangan kunlardagi ish vaqtini ko‘rsating",
  publicTradingPoint: "Savdo nuqtasini rcpay.ru saytida e’lon qilish",
  publicTTDescription: [
    "Savdo nuqtasi rcpay.ru saytida va RC PAY mobil ilovasida o‘z shahridagi ro‘yxatda ko‘rinadi.",
    "RC PAYda joylashish faqat moderatsiya tasdiqlangandan keyin amalga oshadi. Joylashishni o‘chirish uchun ushbu opsiyani o‘chiring, moderatsiya talab qilinmaydi.",
  ],
  workOnline: "Savdo nuqtasi onlayn ishlaydi",
  workOnlineDescription: [
    "Ta’minlangan xizmatlar/mahsulotlar faqat masofadan/yuk bilan sotiladi.",
    "«Manzil» maydonida xaritada savdo nuqtasini ko‘rsatish uchun taxminiy manzilni kiriting – u RC PAY kartasida ko‘rsatilmaydi, uning o‘rniga «Onlayn» so‘zi chiqadi.",
  ],
  time: "Ish vaqti",
  specifyPhoneNumberOrRemove:
    "Telefon raqamini kiriting yoki maydonni o‘chiring",
  specifyMailOrRemove: "Elektron pochtani kiriting yoki maydonni o‘chiring",
  onlineService: "Onlayn yozuv xizmati",
  specifyLinkIfUseOtherServicesForOnline:
    "Agar mijozlar uchun tayyor onlayn yozuv xizmatidan foydalansangiz, havolani kiriting",
  linkAddress: "Havola manzili",
  addSiteOrSocialMedia: "Sayt yoki ijtimoiy tarmoqlarga havolalar qo‘shish",
  linkName: "Havola nomi",
  linkNameTooltips: [
    "RC PAY’da havolani qanday ko‘rsatishni xohlayotganingizni kiriting, masalan, «Xarid qilish» yoki «Bron qilish».",
    "Hech narsa ko‘rsatilmasa, havola manzili ko‘rsatiladi.",
  ],
  pointPhotos: "Savdo nuqtasi fotosuratlari",
  photosRequirements:
    "Maksimal sifatli, suv belgisi, matn va kollajsiz bo‘lishi kerak",
  logo: "Logotip",
  photoRecomendation: "Rasm bo‘yicha tavsiyalar",
  logoRecomendations: [
    "JPEG, JPG, PNG formati, 10 MB gacha, tomonlar nisbati 1:1",
    "Logotip, mavzuga oid rasm, savdo nuqtasi nomi yoki belgisini ishlatish mumkin",
    "Manzil, telefon va boshqa qo‘shimcha ma’lumotlar bo‘lmagan sifatli rasm",
  ],
  uploadLogo: "Logotipni yuklash",
  noClient: "Mijoz yo‘q",
  giftCard: "Sovg‘a kartasi",
  totalCashbackHints: [
    "Chekda umumiy mukofot foizi ko‘rsatilgan, lekin chekdagi summa amalda yechilgan ballarga mos kelmasligi mumkin.",
    "Bu qaysi mijoz xarid qilgani (ichki yoki tashqi) va uning tarifiga bog‘liq.",
  ],
  previewInRCPay: "RC PAY’da oldindan ko‘rish",
  searchByTable: "Jadval bo‘yicha qidirish",
  noCheckData: "Kvitansiyalar haqida ma'lumot yo'q",

  babySafeSeat: "Bolalar o'tiradigan joy",
  parking: "Avtoturargoh",
  wifi: "WiFi",
  aroundTheClock: "Kun bo'yi",
  "16+": "16+",
  noSmoking: "Chekish man etilgan",
  habitation: "Yashash",
  nutrition: "Ovqatlanish",
  transfer: "Transfer",
  excursion: "Ekskursiyalar",
  cardPay: "Kartadan to'lash",
  foodTakeAway: "Uyga olib ketish uchun ovqat",
  conditioner: "Konditsioner",
  delivery: "Yetkazib berish",
  animalsAllow: "Uy hayvonlari bilan kelish mumkin",
  dogAllow: "It bilan kelish mumkin (35 sm dan past)",
  childrenRoom: "Bolalar xonasi",

  assortment: "Assortiment",
  showcase: "Vitrina",
  menu: "Menyu",
  portfolio: "Portfel",
  price: "Narxlar ro'yxati",
  products: "Tovarlar ",
  productsAndServices: "Tovarlar va xizmatlar",
  services: "Xizmatlar",

  // food
  food: "Oziq-ovqat",
  cafe: "Kafe",
  restaurants: "Restoranlar",
  barsClubs: "Barlar va klublar",
  fastfood: "Fastfud",
  coffeeShop: "Qahvaxonalar",
  canteens: "Ovqatxonalar",
  foodDelivery: "Ovqat va tushlik yetkazib berish",
  vegetables: "Sabzavotlar, mevalar va ko‘katlar",
  pizzeria: "Pitseriya",
  goods: "Mahsulotlar",
  specials: "Maxsus",
  sushiBar: "Sushi bar",
  bakeryProducts: "Non va shirinliklar",
  // shopping
  shopping: "Xarid",
  clothes: "Kiyim-kechak",
  shoes: "Oyoq kiyim",
  accessories: "Aksessuarlar",
  flowers: "Gullar",
  jewerly: "Zargarlik buyumlari",
  booksAndCancellery: "Kitoblar va kantselyariya mollari",
  zooItems: "Hayvonlar uchun tovarlar",
  // health and beauty
  beautyAndHealth: "Go‘zallik va sog‘liq",
  care: "Parvarish",
  spa: "Spa",
  medicine: "Tibbiyot",
  pharmacy: "Dorixona",
  cosmeticAndParfume: "Kosmetika va atirlar",
  cosmetology: "Kosmetologiya",
  nailStudio: "Tirnoq studiyasi",
  barbershop: "Soch tarashxona",
  beautyStudio: "Go‘zallik saloni",
  stylistsAndMakeupers: "Vizajistlar, stilistlar",
  // electronic
  technique: "Texnika",
  electronic: "Elektronika",
  homeAppliances: "Maishiy texnika",
  officeEquipment: "Ofis texnikasi",
  communicationSalon: "Aloqa saloni",
  photoTech: "Foto texnika",
  // house
  house: "Uy",
  householdGoods: "Maishiy tovarlar",
  renovation: "Ta’mirlash",
  furniture: "Mebel",
  garden: "Bog‘ va tomorqa",
  decorAndInterior: "Dekor va interyer",
  dishes: "Idish-tovoq",
  plumbing: "Santexnika",
  buildingMaterials: "Qurilish materiallari",
  homeTextile: "Uy matolari",
  // for children
  forChildren: "Bolalar uchun",
  childClothesAndShoes: "Bolalar kiyimi va oyoq kiyimi",
  childFood: "Bolalar ovqati",
  forMothers: "Onalar uchun",
  toysAndGames: "O‘yinchoqlar va o‘yinlar",
  childSections: "Bolalar bo‘limlari",
  // entertaiments
  entertaiments: "Ko‘ngilochar joylar",
  parks: "Bog‘lar",
  cinema: "Kino",
  spaces: "Maydonlar",
  entertainmentCenter: "Ko‘ngilochar markaz",
  // sport
  sport: "Sport",
  clothesAndShoes: "Kiyim va oyoq kiyim",
  turizm: "Turizm",
  sportGym: "Sport zallari",
  swimmingPool: "Suv havzasi (basseyn)",
  specClothes: "Maxsus kiyimlar",
  sportClotheAndShoes: "Sport kiyim va oyoq kiyim",
  sportNutrition: "Sport oziq-ovqati",
  sportSections: "Sport bo‘limlari",
  sportItems: "Sport mollari",
  danceStudio: "Raqs studiyalari",
  // hobby
  hobby: "Xobbi",
  specShops: "Ixtisoslashgan do‘konlar",
  studios: "Studiyalar",
  handicraftsAndCreativeProducts: "Qo‘l mehnati va ijod mahsulotlari",
  // services
  computerHelping: "Kompyuter yordami",
  photoAndVideo: "Foto va video",
  giftsAndHolidays: "Sovg‘alar, bayramlar",
  leisure: "Bo‘sh vaqt",
  repairAndInterior: "Ta’mir va interyer",
  rentAndRental: "Ijaraga berish va olish",
  traveling: "Sayohat",
  studying: "O‘qish",
  atelier: "Atelye",
  autoServices: "Avto xizmatlar",
  householdServices: "Maishiy xizmatlar",
  cargoTransporation: "Yuk tashish",
  legalServices: "Yuridik xizmatlar",
  cleaning: "Tozalash (klining)",
  consultations: "Maslahatlar",
  supermarkets: "Supermarketlar",
  buildingAndReparir: "Qurilish va ta’mirlash",
  // other
  others: "Boshqa",
  gasStations: "Yo‘l yoqasi yonilg‘i shaxobchalari (AZS)",
  halal: "Halol",
  // rent and booking
  rentAndBooking: "Ijara va bron qilish",
  apartments: "Kvartiralar",
  houseRental: "Uy ijarasi",
  boutiqueHotel: "Butik mehmonxona",
  guesthouse: "Mehmon uyi",
  resortHotel: "Kurort mehmonxonasi",
  motel: "Motel",
  hotels: "Mehmonxonalar",
  sanatorium: "Sanatoriy",
  hostel: "Hostel",
  // tourism
  tourismOfHakasia: "Xakasiya turizmi",
  excursionsOfHakasia: "Xakasiyadagi ekskursiyalar",
  nutritionOfHakasia: "Xakasiyadagi ovqatlanish",
  trasportOfHakasia: "Xakasiyadagi transport",
};
